exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\n  box-sizing: border-box;\n}\n.modeldiv{\n  width: 30em;\n  position: fixed;\n  top: 40%;\n  left: 45%;\n}\n\n.contentdiv{\n  height: 25em;\n}\n\n.statusdiv {\n  margin-left: 3em;\n  margin-top: 2em;\n}\n\n.statusLabel{\n  position: fixed;\n  bottom: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/zatcatransaction/zatcatransaction.component.css
// module id = ../../../../../src/app/shared/component/zatcatransaction/zatcatransaction.component.css
// module chunks = main